import { render, staticRenderFns } from "./CAPage.vue?vue&type=template&id=c8d9c75e&scoped=true"
import script from "./CAPage.vue?vue&type=script&lang=js"
export * from "./CAPage.vue?vue&type=script&lang=js"
import style0 from "./CAPage.vue?vue&type=style&index=0&id=c8d9c75e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d9c75e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8d9c75e')) {
      api.createRecord('c8d9c75e', component.options)
    } else {
      api.reload('c8d9c75e', component.options)
    }
    module.hot.accept("./CAPage.vue?vue&type=template&id=c8d9c75e&scoped=true", function () {
      api.rerender('c8d9c75e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/IdentityKYC/components/CAPage.vue"
export default component.exports